<h2 mat-dialog-title>Lock trading</h2>
<mat-dialog-content>
    @if (data.botName) {
        <p>
            Bot <strong>{{ data.botName }}</strong> on broker account <strong>{{ data.brokerAccountName }}</strong>
        </p>
        <p>No new order is placed for this bot until it is unlocked.</p>
    } @else {
        <p>
            Broker account <strong>{{ data.brokerAccountName }}</strong>
        </p>
        <p>No new order is placed for any bot on it, conditional orders included, until it is unlocked.</p>
    }
    <p>
        Orders already placed stay, and nothing is sold. The lock is posted to the Service group with your e-mail and
        the reason.
    </p>
    <mat-form-field class="w-100">
        <mat-label>Reason</mat-label>
        <textarea matInput rows="3" [formControl]="reason"></textarea>
        <mat-hint>Required</mat-hint>
        <mat-hint align="end">{{ reason.value.trim().length }} / {{ reasonMaxLength }}</mat-hint>
        @if (reason.hasError("required")) {
            <mat-error>Enter a reason.</mat-error>
        } @else if (reason.hasError("maxlength")) {
            <mat-error>The reason is longer than {{ reasonMaxLength }} characters.</mat-error>
        }
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-flat-button type="button" [disabled]="reason.invalid" (click)="confirm()">Lock trading</button>
</mat-dialog-actions>
